export enum IconType {
  Logo = "logo",
  LogoAdvisory = "logo-advisory",
  LogoAdvisoryDark = "logo-advisory-dark",
  LogoBaselineNL = "logo-baseline-nl",
  LogoBaselineFR = "logo-baseline-fr",
  LogoBaselineEN = "logo-baseline-en",
  LogoP = "logo-p",
  NoResults = "no-results",
  Caret = "caret",
  CaretFilled = "caret-filled",
  CaretFilledDown = "caret-filled-down",
  Cancel = "cancel",
  UrlLink = "url-link",
  Email = "email",
  Phone = "phone",
  List = "list",
  Map = "map",
  Location = "location",
  Facebook = "facebook",
  Twitter = "twitter",
  ShareLink = "share-link",
  Calculator = "calculator",
  Percentage = "percentage",
  Scale = "scale",
  FoldedBanknote = "folded-banknote",
  MoneyGraph = "money-graph",
  MoneyHand = "money-hand",
  BarGraph = "bar-graph",
  LineGraph = "line-graph",
  DigitalProcess = "digital-process",
  Hat = "hat",
  StreetSign = "street-sign",
  Medal = "medal",
  Mountains = "mountains",
  Search = "search",
  Check = "check",
  Gallery = "gallery",
  Filters = "filters",
  Link = "link",
  Message = "message",
  Settings = "settings",
  Clock = "clock",
  PRect = "p-rect",
  YoutubeIcon = "youtube",
  InstagramIcon = "instagram",
  LinkedinIcon = "linkedin",
  TiktokIcon = "tiktok",
  FacebookIcon = "facebook",
  DownloadIcon = "download",
  Star = "star",
}
